import * as React from 'react';

function SvgMessageReplied(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 3h10c3 0 5 1.5 5 5v3.14c0 .73-.75 1.19-1.42.9a6.51 6.51 0 00-3.66-.45c-2.62.43-4.76 2.5-5.29 5.1-.15.76-.17 1.5-.07 2.21.08.59-.4 1.11-.99 1.11H7c-3 0-5-1.5-5-5V8c0-3.5 2-5 5-5zm-.47 5.59l3.13 2.5c.66.53 1.5.79 2.34.79.84 0 1.69-.26 2.34-.79l3.13-2.5a.77.77 0 00.12-1.06.748.748 0 00-1.05-.12l-3.13 2.5c-.76.61-2.05.61-2.81 0l-3.13-2.5a.738.738 0 00-1.05.12c-.26.32-.21.8.11 1.06z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 18c0-2.77-2.24-5-5-5-2.77 0-5 2.24-5 5s2.24 5 5 5 5-2.23 5-5zm-6.861-.588a.473.473 0 000 .675l.002.002 1.271 1.271c.096.096.217.14.338.14a.472.472 0 00.337-.14.48.48 0 000-.675l-.458-.458h2.667a.48.48 0 00.478-.478.481.481 0 00-.478-.477H17.63l.458-.459a.48.48 0 000-.674.48.48 0 00-.675 0l-1.273 1.273z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMessageReplied;
